<h2 mat-dialog-title class="mat-h2">
  Instructions
  <button mat-icon-button class="close-button" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <div class="row">
    @if (data) {
      <div class="col-12 instructions">
        @for (comment of sortedData; track comment) {
          <div>
            @if (comment?.projectComment?.trim() != '') {
              <div>
                <mat-label class="mat-subtitle-2 bold-title">
                  {{ comment?.sampleTypeName }}
                </mat-label>
                <div>
                  <span class="mat-subtitle-2 instructions-text">
                    {{ comment?.projectComment }}
                  </span>
                </div>
              </div>
            }
          </div>
        }
        @if (hasNoInstructions()) {
          <div>
            <p class="truncate-label">No instructions available.</p>
          </div>
        }
      </div>
    }
  </div>
</mat-dialog-content>
